export const translations = {
  no: {
    header: {
      login: 'Logg inn',
      languageLabel: 'Språk',
    },
    nav: {
      training: 'Trening',
      nutrition: 'Ernæring',
      recipes: 'Oppskrifter',
      shop: 'Handle',
    },
    media: {
      hero: 'Atlet som trener i et moderne treningssenter',
      gym: 'Styrketrening med vekter',
      lift: 'Fokusert styrkeøkt med vekter',
      hiit: 'Høyintensiv trening i studio',
      yoga: 'Mobilitet og bevegelighet',
      bowl: 'Fersk og fargerik måltidsbowl',
      chicken: 'Proteinrikt måltid med grønnsaker',
      meal: 'Planlagte måltider med friske råvarer',
      market: 'Ferske råvarer i butikken',
      run: 'Løper langs en åpen vei',
      fresh: 'Friske grønnsaker og sunn mat',
    },
    hero: {
      brand: 'FitAI365',
      line1: 'DIN FORM.',
      line2: 'DIN PLAN.',
      line3: 'HVER DAG.',
      sub: 'FitAI365 er din KI-coach for trening, kosthold og vaner. Få skreddersydde økter, smarte måltidsplaner og oppskrifter som passer livet ditt — på norsk, døgnet rundt.',
      cta: 'Start i dag',
      ctaSecondary: 'Se plattformen',
      stats: [
        { value: '24/7', label: 'Personlig KI-støtte' },
        { value: '1200+', label: 'Oppskrifter og måltidstips' },
        { value: '600+', label: 'Øvelser og videoøkter' },
      ],
    },
    ticker: [
      'Skreddersydde treningsøkter',
      'Måltidsplaner som fungerer',
      'Kalori- og makrooversikt',
      'KI-genererte oppskrifter',
      'Veiledning på ditt språk',
      'Videoøkter når det passer',
    ],
    problems: {
      kicker: 'Hvorfor det stopper opp',
      title: 'God helse blir vanskelig når alt står i hver sin app',
      sub: 'Du vet at trening og kosthold hører sammen. Likevel ender de fleste opp med løse tips, dyre timer og planer som forsvinner etter en uke.',
      items: [
        {
          title: 'Alt er spredt',
          desc: 'Treningsapper, kostholdsapper og handlelister lever hver for seg. Du mister oversikt og motivasjon.',
        },
        {
          title: 'Personlig hjelp koster for mye',
          desc: 'En coach og en ernæringsrådgiver gir resultater, men prisen gjør det utilgjengelig for de fleste.',
        },
        {
          title: 'Vaner faller bort',
          desc: 'Uten daglig oppfølging blir det lett å hoppe over økter, glemme logging og miste tråden.',
        },
        {
          title: 'Planlegging tar for lang tid',
          desc: 'Å bygge økter, telle makroer og finne middager hver uke stjeler tid du heller vil bruke på å trene.',
        },
      ],
    },
    platform: {
      kicker: 'Slik hjelper FitAI365',
      title: 'Én intelligent hub for trening og mat',
      sub: 'FitAI365 kobler coaching, planlegging, sporing og oppskrifter sammen, slik at du får konkrete neste steg i stedet for mer støy.',
      coachTitle: 'En coach som svarer når du trenger det',
      coachDesc: 'Still spørsmål, få øktforslag, be om en oppskrift eller logg et måltid. Coachen tilpasser seg målene dine underveis.',
      coachPill: 'Raske, tydelige svar',
      items: [
        {
          title: 'Oppskrifter fra det du har',
          desc: 'Generer sunne retter fra ingrediensene i kjøleskapet — eller fra et bilde av maten.',
        },
        {
          title: 'Video basert veiledning',
          desc: 'Følg økter med klar instruksjon som matcher nivået ditt.',
        },
        {
          title: 'Samtale på norsk',
          desc: 'Skriv eller snakk med coachen på språket du er komfortabel med.',
        },
        {
          title: 'Øvelsesbibliotek',
          desc: 'Finn øvelser etter muskelgruppe, utstyr og vanskelighetsgrad.',
        },
        {
          title: 'Øktportal',
          desc: 'Styrke, HIIT, mobilitet og roligere økter samlet på ett sted.',
        },
        {
          title: 'Smarte oppskriftsfiltre',
          desc: 'Filtrer på kalorier, preferanser, allergener og tid.',
        },
      ],
    },
    nutrition: {
      kicker: 'Ernæring i praksis',
      title: 'Fra tall til valg du faktisk kan følge',
      sub: 'FitAI365 gjør kalorier, makroer og måltider lesbare — så du ser hva som skal skje i dag, ikke bare hva som skjedde i går.',
      features: [
        'Daglig kalorioversikt',
        'Protein, karbohydrater og fett',
        'Enkel måltidslogging',
        'Oppskrifter som går rett inn i sporingen',
        'KI-hjelp til porsjonsestimering',
      ],
      calculatorTitle: 'Mål tilpasset deg',
      calculatorSub: 'Anbefalingene bygges blant annet på:',
      calculatorInputs: ['Alder', 'Kjønn', 'Vekt', 'Høyde', 'Aktivitetsnivå', 'Treningsmål'],
      macros: [
        { label: 'Protein', pct: 35 },
        { label: 'Karbohydrater', pct: 40 },
        { label: 'Fett', pct: 25 },
      ],
      dailyGoal: 'Dagens fordeling',
    },
    recipes: {
      kicker: 'Mat som støtter målene',
      title: 'Ernæring uten endeløs googling',
      sub: 'Få forslag som passer preferansene dine, med næringsinfo du kan stole på.',
      libraryTitle: 'Biblioteket ditt',
      library: [
        'Sunde oppskrifter med nyttige filtre',
        'Støtte for ulike kostholdspreferanser',
        'Anbefalinger som tar hensyn til allergener',
        'Måltider tilpasset kalorimålene dine',
      ],
      outputTitle: 'Hver KI-oppskrift viser',
      output: [
        'Kalorier',
        'Protein, karbohydrater og fett',
        'Porsjonsstørrelser',
        'Allergener',
        'Tilberedningstid',
        'Fullstendig ingrediensliste',
      ],
    },
    grocery: {
      kicker: 'Handle smartere',
      title: 'Fra ukemeny til handleliste uten kaos',
      sub: 'La FitAI365 bygge listen fra måltidsplanen din og hjelpe deg å holde både ernæring og budsjett i sjakk.',
      steps: [
        'Lag handlelister automatisk ut fra valgte oppskrifter og ukemenyer.',
        'Sammenlign priser hos deltakende dagligvarekjeder.',
        'Se hvilken butikk som gir lavest totalsum for hele listen.',
        'Få et estimert beløp før du drar ut døren.',
        'Velg sunnere alternativer uten å miste kontroll på kostnadene.',
        'Hold måltidsplan, ernæring og handleplan i samme flyt.',
      ],
    },
    vision: {
      kicker: 'Retningen vår',
      title: 'Personlig coaching skal ikke være en luksus',
      statement: 'Vi gjør KI-drevet trening og ernæringsstøtte tilgjengelig hver dag — rimelig, tydelig og tilpasset deg.',
      cards: [
        {
          title: 'Tilgjengelig for flere',
          desc: 'Premium veiledning skal nå flere mennesker, ikke bare de som har råd til privat coaching.',
        },
        {
          title: 'KI med retning',
          desc: 'Vi bygger en europeisk plattform der fitness og mat møtes i én intelligent opplevelse.',
        },
        {
          title: 'Kontinuerlig utvikling',
          desc: 'Vi investerer i bedre modeller, mer innhold og en plattform som vokser med brukerne.',
        },
      ],
    },
    cta: {
      title: 'Klar for en plan som følger deg?',
      sub: 'Start med FitAI365 og få trening, kosthold og daglig støtte samlet på ett sted.',
      button: 'Kom i gang med FitAI365',
      note: 'Ingen binding. Avslutt når du vil.',
    },
    footer: {
      blurb: 'FitAI365 er en KI-drevet fitness- og ernæringsplattform med personlige treningsøkter, måltidsplanlegging, kalorisporing og KI-genererte oppskrifter. Tjenesten koster kr. 199,- per måned inkludert mva. og belastes via mobilregningen din. Abonnementet er løpende og kan sies opp når som helst. For å avslutte abonnementet, send FITAI STOPP via SMS til 2210. Du mottar alltid en gratis bekreftelse på oppsigelsen. Aldersgrense 18 år. Ved spørsmål, kontakt oss på help@niffomobile.com.',
      links: [
        { label: 'Vilkår og betingelser', href: '/vilkar.html' },
        { label: 'Personvernerklæring', href: '/personvern.html' },
        { label: 'Kontakt', href: 'mailto:help@niffomobile.com' },
      ],
      contactTitle: 'Kontakt',
      company: 'Niffo Mobile B.V.',
      address: 'Stationsplein 28, 1382 AD Weesp, Nederland',
      email: 'help@niffomobile.com',
      copyright: 'Copyright © 2026 FitAI365 | KI-drevet fitness | Med enerett.',
    },
  },

  en: {
    header: {
      login: 'Login',
      languageLabel: 'Language',
    },
    nav: {
      training: 'Training',
      nutrition: 'Nutrition',
      recipes: 'Recipes',
      shop: 'Grocery',
    },
    media: {
      hero: 'Athlete training in a modern gym',
      gym: 'Strength training with weights',
      lift: 'Focused weightlifting session',
      hiit: 'High-intensity studio training',
      yoga: 'Mobility and movement practice',
      bowl: 'Fresh colourful meal bowl',
      chicken: 'High-protein meal with vegetables',
      meal: 'Planned meals with fresh ingredients',
      market: 'Fresh groceries at the store',
      run: 'Runner on an open road',
      fresh: 'Fresh produce and healthy food',
    },
    hero: {
      brand: 'FitAI365',
      line1: 'YOUR BODY.',
      line2: 'YOUR PLAN.',
      line3: 'EVERY DAY.',
      sub: 'FitAI365 is your AI coach for training, nutrition and habits. Get tailored workouts, smarter meal plans and recipes that fit real life — in your language, around the clock.',
      cta: 'Start today',
      ctaSecondary: 'See the platform',
      stats: [
        { value: '24/7', label: 'Personal AI support' },
        { value: '1200+', label: 'Recipes and meal ideas' },
        { value: '600+', label: 'Exercises and video sessions' },
      ],
    },
    ticker: [
      'Tailored workouts',
      'Meal plans that stick',
      'Calorie and macro clarity',
      'AI-generated recipes',
      'Guidance in your language',
      'Video sessions on your schedule',
    ],
    problems: {
      kicker: 'Where progress stalls',
      title: 'Health gets hard when everything lives in separate apps',
      sub: 'You know training and nutrition belong together. Yet most people end up with scattered tips, expensive sessions and plans that fade after a week.',
      items: [
        {
          title: 'Everything is fragmented',
          desc: 'Workout apps, food apps and shopping lists never sync. You lose overview — and momentum.',
        },
        {
          title: 'Personal help costs too much',
          desc: 'A coach and a nutrition expert work, but the price puts them out of reach for most people.',
        },
        {
          title: 'Habits slip away',
          desc: 'Without daily follow-up it is easy to skip sessions, forget logging and lose the thread.',
        },
        {
          title: 'Planning eats the week',
          desc: 'Building workouts, counting macros and finding dinners every week steals time you would rather spend training.',
        },
      ],
    },
    platform: {
      kicker: 'How FitAI365 helps',
      title: 'One intelligent hub for training and food',
      sub: 'FitAI365 connects coaching, planning, tracking and recipes so you get clear next steps instead of more noise.',
      coachTitle: 'A coach that answers when you need it',
      coachDesc: 'Ask a question, get a session idea, request a recipe or log a meal. The coach adapts as your goals evolve.',
      coachPill: 'Fast, clear replies',
      items: [
        {
          title: 'Recipes from what you have',
          desc: 'Generate healthy dishes from fridge ingredients — or from a photo of your food.',
        },
        {
          title: 'Video-based guidance',
          desc: 'Follow sessions with clear instruction matched to your level.',
        },
        {
          title: 'Natural conversation',
          desc: 'Chat with your coach in the language you prefer.',
        },
        {
          title: 'Exercise library',
          desc: 'Browse moves by muscle group, equipment and difficulty.',
        },
        {
          title: 'Session portal',
          desc: 'Strength, HIIT, mobility and easier days in one place.',
        },
        {
          title: 'Smart recipe filters',
          desc: 'Filter by calories, preferences, allergens and time.',
        },
      ],
    },
    nutrition: {
      kicker: 'Nutrition in practice',
      title: 'From numbers to choices you can keep',
      sub: 'FitAI365 makes calories, macros and meals readable — so you see what to do today, not only what happened yesterday.',
      features: [
        'Daily calorie overview',
        'Protein, carbs and fat',
        'Simple meal logging',
        'Recipes that feed into tracking',
        'AI help with portion estimates',
      ],
      calculatorTitle: 'Targets built around you',
      calculatorSub: 'Recommendations are shaped by inputs like:',
      calculatorInputs: ['Age', 'Gender', 'Weight', 'Height', 'Activity level', 'Training goals'],
      macros: [
        { label: 'Protein', pct: 35 },
        { label: 'Carbs', pct: 40 },
        { label: 'Fat', pct: 25 },
      ],
      dailyGoal: 'Today’s split',
    },
    recipes: {
      kicker: 'Food that supports the plan',
      title: 'Nutrition without endless searching',
      sub: 'Get suggestions that match your preferences, with nutrition info you can trust.',
      libraryTitle: 'Your library',
      library: [
        'Healthy recipes with useful filters',
        'Support for different dietary preferences',
        'Recommendations that respect allergens',
        'Meals aligned with your calorie targets',
      ],
      outputTitle: 'Every AI recipe includes',
      output: [
        'Calories',
        'Protein, carbs and fats',
        'Serving sizes',
        'Allergens',
        'Prep time',
        'Full ingredients list',
      ],
    },
    grocery: {
      kicker: 'Smarter shopping',
      title: 'From weekly menu to grocery list without the chaos',
      sub: 'Let FitAI365 build the list from your meal plan and help you protect both nutrition goals and budget.',
      steps: [
        'Generate grocery lists automatically from selected recipes and weekly menus.',
        'Compare prices across participating supermarket chains.',
        'See which store offers the lowest total for the full list.',
        'Get an estimated spend before you leave home.',
        'Choose healthier options without losing cost control.',
        'Keep meal planning, nutrition and shopping in one flow.',
      ],
    },
    vision: {
      kicker: 'Our direction',
      title: 'Personal coaching should not be a luxury',
      statement: 'We make AI-powered training and nutrition support available every day — affordable, clear and built around you.',
      cards: [
        {
          title: 'Reach more people',
          desc: 'Premium guidance should reach more people, not only those who can afford private coaching.',
        },
        {
          title: 'AI with a clear path',
          desc: 'We are building a European platform where fitness and food meet in one intelligent experience.',
        },
        {
          title: 'Continuous improvement',
          desc: 'We invest in better models, richer content and a platform that grows with its users.',
        },
      ],
    },
    cta: {
      title: 'Ready for a plan that stays with you?',
      sub: 'Start with FitAI365 and bring training, nutrition and daily support into one place.',
      button: 'Get started with FitAI365',
      note: 'No lock-in. Cancel anytime.',
    },
    footer: {
      blurb: 'FitAI365 is an AI-powered fitness and nutrition platform with personalized workouts, meal planning, calorie tracking and AI-generated recipes. The service costs NOK 199 per month including VAT and is charged via your mobile bill. The subscription is ongoing and can be cancelled at any time. To cancel your subscription, send FITAI STOP via SMS to 2210. You will always receive a free confirmation of your cancellation. Age limit 18 years. For questions, contact us at help@niffomobile.com.',
      links: [
        { label: 'Terms and conditions', href: '/vilkar.html' },
        { label: 'Privacy policy', href: '/personvern.html' },
        { label: 'Contact', href: 'mailto:help@niffomobile.com' },
      ],
      contactTitle: 'Contact',
      company: 'Niffo Mobile B.V.',
      address: 'Stationsplein 28, 1382 AD Weesp, Netherlands',
      email: 'help@niffomobile.com',
      copyright: 'Copyright © 2026 FitAI365 | AI-powered fitness | All rights reserved.',
    },
  },
};
